import { useHowlerLazyQuery } from 'hooks';

import { GET_VERIFIED_EMAILS_QUERY } from './useGetVerifiedEmails.graphql';
import {
  IGetVerifiedEmailsQueryGraphQLResponse,
  IGetVerifiedEmailsQueryVariables,
  IHandleGetVerifiedEmailsParams,
  IUseGetVerifiedEmails,
  IUseGetVerifiedEmailsOptions,
} from './useGetVerifiedEmails.interfaces';

const useGetVerifiedEmails = (options?: IUseGetVerifiedEmailsOptions): IUseGetVerifiedEmails => {
  const { fetchPolicy, onCompleted, onError, query, token } = options ?? ({} as IUseGetVerifiedEmailsOptions);

  const [executeGetVerifiedEmails, { loading: isLoading }] = useHowlerLazyQuery<
  IGetVerifiedEmailsQueryGraphQLResponse,
  IGetVerifiedEmailsQueryVariables
  >({
    options: {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: fetchPolicy ?? 'cache-and-network',
      onCompleted: (data) => {
        if (!onCompleted) {
          return;
        }

        const {
          project: { listVerifiedEmails: verifiedEmails },
        } = data;

        void onCompleted({
          verifiedEmails,
        });
      },
      onError,
    },
    query: query ?? GET_VERIFIED_EMAILS_QUERY,
    token,
  });


  const handleGetVerifiedEmails = ({ projectId }: IHandleGetVerifiedEmailsParams) => {
    void executeGetVerifiedEmails({
      variables: {
        projectId,
      },
    });
  };

  return {
    handleGetVerifiedEmails,
    isLoading,
  };
};

export { useGetVerifiedEmails };
